import React from 'react';
import { Grid, Box } from '@mui/material';

const Legend = ({ name, width, opacity, margin }) => {
  return (
      <label htmlFor="image-input" style={{ 
          display: 'inline-flex', 
          alignItems: 'center', 
          marginLeft: `${margin}`, 
          fontSize: '12px', 
          marginTop: '-59px', 
          position:'absolute', 
          zIndex: 1
          }}> {/* Inline styles for label */}
          <Box
            className="chip"
            sx={{
              backgroundColor: `rgba(0, 0, 0, ${opacity})`,
              border: '1px solid #D0D6D7',
              width: `${width}`,
              height: '14px',
              zIndex: 1, // No need for string '1'
            }}
          />
          <span style={{ marginLeft: '4px' }}> {/* Inline style for spacing */}
            { name }
          </span>
      </label>
  );
};

export default Legend;